import { FC, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from '@bonusly/design-system';

interface SendSpotlightConfirmationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isSending?: boolean;
	subjectDisplayName: string;
}

export const SendSpotlightConfirmationModal: FC<SendSpotlightConfirmationModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	isSending = false,
	subjectDisplayName,
}) => {
	const { t } = useTranslation('spotlight');
	const cancelRef = useRef<HTMLButtonElement>(null);

	return (
		<AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={!isSending} closeOnEsc={!isSending}>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">
						{t('callToAction.persona.manager.sendSpotlightModal.title')}
					</AlertDialogHeader>

					<AlertDialogBody>
						<Trans i18nKey="callToAction.persona.manager.sendSpotlightModal.body" ns="spotlight" values={{ name: subjectDisplayName }} />
					</AlertDialogBody>

					<AlertDialogFooter>
						<Button ref={cancelRef} onClick={onClose} variant="ghost" colorScheme="secondary" isDisabled={isSending}>
							{t('callToAction.persona.manager.sendSpotlightModal.cancel')}
						</Button>
						<Button colorScheme="primary" onClick={onConfirm} ml={3} isLoading={isSending}>
							{t('callToAction.persona.manager.sendSpotlightModal.confirm')}
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};
